import { MorningBriefItem } from "@/services/APIs/FoodScannerService";
import { 
  CheckCircle2, 
  TrendingUp, 
  Target, 
  Pill,
  AlertTriangle,
  Info,
  XCircle 
} from "lucide-react";
import { Card } from "antd";

interface MorningBriefProps {
  items: MorningBriefItem[];
}

const getIcon = (iconName: string, type: string) => {
  const iconProps = { size: 18 };
  
  const iconMap: Record<string, JSX.Element> = {
    check: <CheckCircle2 {...iconProps} className="text-green-500" />,
    trending: <TrendingUp {...iconProps} className="text-yellow-500" />,
    target: <Target {...iconProps} className="text-blue-500" />,
    pill: <Pill {...iconProps} className="text-red-500" />,
    warning: <AlertTriangle {...iconProps} className="text-yellow-500" />,
    info: <Info {...iconProps} className="text-blue-500" />,
    error: <XCircle {...iconProps} className="text-red-500" />,
  };

  // Return icon based on type if iconName not found
  if (iconMap[iconName]) {
    return iconMap[iconName];
  }

  // Fallback based on type
  switch (type) {
    case "success":
      return <CheckCircle2 {...iconProps} className="text-green-500" />;
    case "warning":
      return <AlertTriangle {...iconProps} className="text-yellow-500" />;
    case "error":
      return <Pill {...iconProps} className="text-red-500" />;
    default:
      return <Info {...iconProps} className="text-blue-500" />;
  }
};

const MorningBrief: React.FC<MorningBriefProps> = ({ items }) => {
  if (!items || items.length === 0) {
    return null;
  }

  return (
    <Card 
      className="mb-6 shadow-sm hover:shadow-md transition-shadow duration-200"
      style={{ 
        backgroundColor: 'var(--card-bg)',
        borderColor: 'var(--border-color)'
      }}
    >
      <div className="flex items-center gap-2 mb-4">
        <TrendingUp size={20} className="text-yellow-500" />
        <h2 className="text-lg font-semibold m-0" style={{ color: 'var(--text-primary)' }}>
          MORNING BRIEF
        </h2>
      </div>
      
      <div className="space-y-3">
        {items.map((item, index) => (
          <div 
            key={index} 
            className="flex items-start gap-3 p-2 rounded hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors duration-150"
          >
            <div className="flex-shrink-0 mt-0.5">
              {getIcon(item.icon, item.type)}
            </div>
            <span 
              className="text-sm leading-relaxed" 
              style={{ color: 'var(--text-secondary)' }}
            >
              {item.text}
            </span>
          </div>
        ))}
      </div>
    </Card>
  );
};

export default MorningBrief;
